module.exports = __webpack_public_path__ + "static/media/w (15).73dc0af4.jpg";